import gql from 'graphql-tag';

export default gql`
mutation UpdateUser(
        $uuid: String!,
        $name: String!,
        $desc: String,
        $image: String,
        $langs: String,
        $locale: String,
        $payout: String,
        $payoutPayPalEmail: String
        ) {
    updateUsers(input:{
        uuid: $uuid,
        name: $name,
        desc: $desc,
        image: $image,
        langs: $langs,
        locale: $locale,
        payout: $payout,
        payoutPayPalEmail: $payoutPayPalEmail
    }) {
        __typename
    }
}
`;
